import { clampLayerFrame } from './clampLayerFrame';
import type { LayerFrame } from './types';

const fmt = (v: number) => Number(v.toFixed(4));

/** Transform for a full-size inner wrapper inside an overflow-hidden cell:
 *  zoom around center, pan within the zoom overflow (offset ±1 = edge).
 *  Neutral (scale ≤ 1) → undefined so callers skip the wrapper entirely —
 *  absent/neutral frames render byte-identically to the legacy output. */
export function computeReframeTransform(frame: LayerFrame): { transform: string } | undefined {
  const f = clampLayerFrame(frame);
  if (f.scale <= 1) return undefined;
  const max = ((f.scale - 1) / (2 * f.scale)) * 100;
  const tx = fmt(-f.offsetX * max);
  const ty = fmt(-f.offsetY * max);
  return { transform: `scale(${f.scale}) translate(${tx}%, ${ty}%)` };
}
